import React, { useState } from 'react';

import axios from 'axios';
import toast from 'react-hot-toast';

import WorkflowStepper from '../../ReUseable/Stepper/WorkflowStepper';
import CancelModal from '../../ReUseable/Modals/CancelModal';
import { API } from '../../../global';

const CreateWorkflow = (props) => {
  const { setShowCreateWorkflow, setShowUploadFile } = props;
  const [pipelineName, setPipelineName] = useState('');
  const [cancelModalOpen, setCancelModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleNext = async () => {
    if (pipelineName) {
      setLoading(true);
      const config = {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("auth_token")}`
        }
      };
      const fileDetails = {
        pipelineName: pipelineName
      }
      const res = await axios.post(`${API}/pipelines/create`, fileDetails, config);
      if (res.data.success) {
        setLoading(false);
        setShowUploadFile(true);
        setShowCreateWorkflow(false);
        localStorage.setItem("pipelineId", res.data.result._id);
      } else {
        setLoading(false);
        toast.error(res.data.error.msg);
      }
    } else {
      setLoading(false);
      toast.error("Please enter a pipeline name");
    }
  };

  const handleCancel = () => {
    setCancelModalOpen(true);
  };

  const handleModalCancel = () => {
    setCancelModalOpen(false);
  }

  const handleModalProceed = () => {
    setShowCreateWorkflow(false);
    setCancelModalOpen(false);
  }

  return (
    <div className="mt-16 px-5 ms-[50px] py-1">
      <WorkflowStepper
        source={false}
      />
      <div className={`${cancelModalOpen ? 'overflow-hidden h-screen' : ''}`}>
        <div className='mt-24 px-5 mx-[130px]'>
          <div className='text-[#212529] text-[18px]  font-medium'>Create Pipeline</div>
          <div className='flex gap-5 mt-5  font-normal text-sm items-center'>
            <label htmlFor="Validation-Group-Name" className="text-lite-black">
              Pipeline Name
            </label>
            <input
              type="text"
              placeholder="Enter Name"
              className="bg-white border custom-input border-[#C7C7C7] rounded-md w-96 text-lite-black px-2.5 py-1 focus-visible:outline-none" id="Validation-Group-Name"
              value={pipelineName}
              onChange={(e) => setPipelineName(e.target.value)}
            />
          </div>

          <hr className='border-0.5 border-[#C7C7C7] mt-8' />

          <div className='flex justify-end mt-8'>
            <div className='flex gap-2.5 text-sm text-[#ffffff] font-normal'>
              <button
                className='bg-[#BFBFBF] w-16 rounded-md py-1.5'
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                className={`bg-[#0078C5] px-4 rounded-md py-1.5 ${loading ? "disabled" : ""}`}
                onClick={handleNext}
              >
                {loading ? "Loading..." : "Next"}
              </button>
            </div>
          </div>
        </div>

        {cancelModalOpen && (
          <CancelModal
            handleProceed={handleModalProceed}
            handleCancel={handleModalCancel}
          />
        )}
      </div>
    </div>
  )
}

export default CreateWorkflow